export default "__VITE_ASSET__BMg4Pr_n__"